/* site-guard layer 2 — independent of the inline snippet (see snippets/site-guard.liquid).
   Allowlist is base64 so a hostname text-rewrite proxy cannot touch it. Fail-open on any error. */
(function () {
  try {
    var h = String(location.hostname || '').toLowerCase();
    if (!h) return;
    var d = function (s) { return atob(s); };
    var exact = ['ZXBvbWFrZXIuY29t', 'd3d3LmVwb21ha2VyLmNvbQ==', 'ZXBvbWFrZXIubXlzaG9waWZ5LmNvbQ==', 'bG9jYWxob3N0', 'MTI3LjAuMC4x', 'd2ViLmFyY2hpdmUub3Jn'];
    var suffix = ['Lm15c2hvcGlmeS5jb20=', 'LnNob3BpZnlwcmV2aWV3LmNvbQ==', 'LnRyYW5zbGF0ZS5nb29n'];
    var i, s;
    for (i = 0; i < exact.length; i++) { if (h === d(exact[i])) return; }
    for (i = 0; i < suffix.length; i++) { s = d(suffix[i]); if (h.length > s.length && h.slice(-s.length) === s) return; }

    var real = d(exact[0]);
    if (typeof window.__sgFail === 'function') { window.__sgFail(h, real); return; }
    if (window.__sgDone) return;
    window.__sgDone = 1;

    var path = String(location.pathname || '/').replace(/[^A-Za-z0-9\/_\-.%]/g, '') || '/';
    var target = 'https://' + real + path;
    var esc = function (v) { return String(v).replace(/[&<>"']/g, function (c) { return '&#' + c.charCodeAt(0) + ';'; }); };
    try { window.stop(); } catch (e) {}
    var render = function () {
      document.documentElement.innerHTML =
        '<head id="sgh"><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><meta name="robots" content="noindex,nofollow"><title>Warning: unofficial website</title>' +
        '<style>html,body{margin:0;background:#060B10;color:#fff;font:16px/1.5 -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif}html>*:not(#sgh):not(#sgb){display:none!important}' +
        '#sgb{min-height:100vh;display:flex;align-items:center;justify-content:center;padding:24px;box-sizing:border-box}.sg{max-width:560px;width:100%;background:#0B131C;border:1px solid rgba(255,255,255,.08);border-radius:20px;padding:36px 32px}' +
        '.sg h1{font-size:28px;line-height:1.15;margin:0 0 14px;font-weight:800}.sg p{margin:0 0 12px;color:rgba(255,255,255,.72)}.sg code{font:14px ui-monospace,Menlo,monospace;background:rgba(255,255,255,.06);padding:2px 8px;border-radius:6px;color:#fff;word-break:break-all}' +
        '.sg a{display:block;text-align:center;margin:26px 0 12px;background:#0099FF;color:#fff;text-decoration:none;font-weight:700;padding:15px 20px;border-radius:12px}.sg small{display:block;text-align:center;color:rgba(255,255,255,.45);font-size:13px}</style></head>' +
        '<body id="sgb"><div class="sg" role="alert"><h1>This is not the official EPOMAKER website</h1>' +
        '<p>You are viewing a copy of our store served from <code>' + esc(h) + '</code>. This address is not operated by EPOMAKER.</p>' +
        '<p><strong style="color:#fff">Do not enter your password, address or payment details on this page.</strong></p>' +
        '<p>Our only official store is <code>' + esc(real) + '</code>.</p>' +
        '<a href="' + esc(target) + '" rel="noopener">Go to the official EPOMAKER store</a>' +
        '<small>Redirecting automatically in <span id="sgn">8</span>s…</small></div></body>';
      try {
        new MutationObserver(function () {
          var c = document.documentElement.childNodes, j;
          for (j = c.length - 1; j >= 0; j--) { if (c[j].id !== 'sgh' && c[j].id !== 'sgb') document.documentElement.removeChild(c[j]); }
        }).observe(document.documentElement, { childList: true });
      } catch (e) {}
      var n = 8, el = document.getElementById('sgn');
      var t = setInterval(function () { n--; if (el) el.textContent = n; if (n <= 0) { clearInterval(t); location.replace(target); } }, 1000);
    };
    render();
  } catch (e) {}
})();
